import React from 'react'
import WebGLBackground from '../WebGLBackground'
import styles from './PageBackdrop.module.css'

const PageBackdrop = () => (
  <div className={styles.backdrop} aria-hidden="true">
    <div className={styles.mesh} />
    <WebGLBackground />
    <div className={styles.grid} />
    <div className={styles.noise} />
  </div>
)

export default PageBackdrop
